import React from "react";
import s from "./MainEducation.module.css";
import TopTitleBlock from "../../Components/TopTitleBlock/TopTitleBlock";
import MainEducationProgressLineTop from "./EducationComponents/MainEducationProgressLineTop";
import EducationModules from "./EducationComponents/EducationModules";
import EducationBackButton from "../../Components/Buttons/EducationBackButton";
import {useSelector} from "react-redux";

const EducationModuleLessonsPage = () => {
  const apiData = useSelector((state)=>state.appData.appData)
  return (
    <main className={`${s.mainEducation} page`}>
      <div className="container">
        <div className="page__content">
          <TopTitleBlock
            titleBack={apiData.button_back}
            pagination={
              "PPRODUCT SCHOOL > White mandarin > Модуль 3. Огляд продуктів > \n" +
              "> Підрозділ 1. Догляд за шкірою обличчя "
            }
          />
          <EducationBackButton />
          <div className={s.titleLesson}>
            <h3>підрозділ 1. догляд за шкірою обличчя</h3>
          </div>
          <div className={s.contentContainer}>
            <MainEducationProgressLineTop text={"Огляд продуктів"} />
            <EducationModules
              title={"Уроки"}
              link={"/main_education/sub_section"}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default EducationModuleLessonsPage;
